import React, { useState, useEffect } from "react";
import { AppBar, Tabs, Tab, ThemeProvider } from "@material-ui/core";
import { Link, Switch, Route, Redirect, useRouteMatch } from "react-router-dom";

import config from "../../dashboard-config";
import PrivateNavbar from "../Navbar/PrivateNavbar";
import ProfilePage from "./ProfilePage";
import APIAccessPage from "./APIAccessPage";
import APIUsagePage from "./APIUsagePage";
import { User } from "../../shared-types/User";
import adminTheme from "./theme";

const Admin: React.FC<{}> = () => {
  // Figure out the current section ID from the URL
  const match = useRouteMatch<{ section: string }>("/admin/:section");
  const currentSection = match?.params.section;

  /** A list of sections that should be linked from this admin view */
  const sections = [
    {
      id: "profile",
      label: "Profile",
      component: ProfilePage
    },
    {
      id: "api-access",
      label: "API Access",
      component: APIAccessPage
    },
    {
      id: "api-usage",
      label: "API Usage",
      component: APIUsagePage
    }
  ];

  const [accountInfo, setAccountInfo] = useState<User | any>(null);
  const profile = JSON.parse(localStorage.getItem("sofar-user") || "{}");

  useEffect(() => {
    fetch(`${config.wavefleetUrl}/users/${profile.username}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        token: profile.token
      })
    })
      .then(res => res.json())
      .then(res => {
        const profile: User = {
          lastName: res.lastname || res.lastName,
          firstName: res.firstname || res.firstName,
          organization: res.company || res.organization,
          email: res.email
        };
        setAccountInfo(profile);
      });
  }, []);

  return (
    <ThemeProvider theme={adminTheme}>
      <PrivateNavbar />
      <AppBar position="relative">
        <Tabs value={currentSection}>
          {sections.map(s => (
            // Render a tab for each section
            <Tab
              key={s.id}
              component={Link}
              to={`/admin/${s.id}`}
              value={s.id}
              label={s.label}
            />
          ))}
        </Tabs>
      </AppBar>

      <Switch>
        {sections.map(s => (
          // Render a route matcher for each section
          <Route
            key={s.id}
            path={`/admin/${s.id}`}
            render={props => <s.component user={accountInfo} />}
          />
        ))}
        <Route
          path="/admin"
          render={() => <Redirect to="admin/profile" />}
        ></Route>
      </Switch>
    </ThemeProvider>
  );
};
export default Admin;
